import React, { useState } from "react";
import { Box, Grid, Stack } from "@mui/material";
import { useMediaQuery } from "react-responsive";
import BackButton from "../../../components/BackButton";

function Heading() {
  const isMobile = useMediaQuery({ maxWidth: "900px" });
  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <Grid
          container
          spacing={2}
          className="d-flex align-items-center justify-content-space-between"
        >
          <Grid item xs={8} md={8}>
            <p className="page-heading-name">Inspector Assign</p>
          </Grid>
          <BackButton />
        </Grid> 
      </Box>
    </>
  );
}

export default Heading;
